import { IManagingLinuxServiceInstance } from '../../api/models';
import { AppEnvironment } from '../../constants/AppEnvironment';
import { LinuxServiceActiveState } from '../../constants/LinuxServiceActiveState';
import { IStyledText, StyledText } from '../UIExtentions/Text';

function GetActiveStateTypeProps(activeState: string, environment: AppEnvironment): IStyledText {
    const warningClass = environment === AppEnvironment.Production ? 'text-orange' : null;
    switch (activeState) {
        case LinuxServiceActiveState.Active:
            return {
                text: 'Active',
                className: environment === AppEnvironment.Production ? 'text-success' : null,
            };
        case LinuxServiceActiveState.Inactive:
            return {
                text: 'Inactive',
                className: warningClass,
            };
        case LinuxServiceActiveState.Failed:
            return {
                text: 'Failed',
                className: warningClass,
            };
        case LinuxServiceActiveState.Activating:
            return {
                text: 'Activating',
                className: warningClass,
            };
        case LinuxServiceActiveState.Deactivating:
            return {
                text: 'Deactivating',
                className: warningClass,
            };
        case LinuxServiceActiveState.Maintenance:
            return {
                text: 'Maintenance',
                className: warningClass,
            };
        case LinuxServiceActiveState.Reloading:
            return {
                text: 'Reloading',
                className: warningClass,
            };
        default:
            return {
                text: activeState,
            };
    }
}

export default function LinuxServiceActiveStateText(serverApp: IManagingLinuxServiceInstance) {
    const activeStateProps = GetActiveStateTypeProps(serverApp.activeState, serverApp.environment as AppEnvironment);

    return <StyledText {...activeStateProps} />;
}
